"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Comment = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const comment_styles_1 = require("./comment.styles");
const single_commenting_dialog_constants_1 = require("../single-commenting-dialog.constants");
const single_commenting_dialog_utils_1 = require("../single-commenting-dialog.utils");
const localization_1 = require("../../../../../../localization");
const hooks_1 = require("../../../../../hooks");
const Comment = ({ comment, shouldCommentBeHighlighted }) => {
    const { formatDate } = (0, localization_1.useLocalization)();
    const row = (0, react_1.useRef)(null);
    (0, hooks_1.useRowHighlighting)({
        targetRef: row,
        scrollToHighlightedItem: true,
        shouldRowBeHighlighted: shouldCommentBeHighlighted,
        value: comment,
        className: 'comment--highlighted',
    });
    /**
     * Temporarily mapping authorId to authorName until API provides this field directly.
     */
    const { authorName, createdAt, content } = comment;
    return (react_1.default.createElement(comment_styles_1.StyledComment, { ref: row, square: true }, react_1.default.createElement(material_1.CardContent, null, react_1.default.createElement(material_1.Avatar, null, (0, single_commenting_dialog_utils_1.getAvatarStub)(authorName)), react_1.default.createElement("div", { className: "comment-text-container" }, react_1.default.createElement(material_1.CardHeader, { disableTypography: true, title: react_1.default.createElement(ui_components_1.Typography, { strong: true, gutterBottom: true, className: "comment-title-user-name", variant: "body2" }, authorName), action: react_1.default.createElement(ui_components_1.Typography, { variant: "caption", color: "textSecondary" }, formatDate(createdAt, single_commenting_dialog_constants_1.commentDateTimeOptions)) }), react_1.default.createElement(ui_components_1.Typography, { variant: "body2", className: "comment-message" }, content)))));
};
exports.Comment = Comment;
exports.default = exports.Comment;
